// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.smallIcon{
    width: 21px;
    height: 21px;
    font-size: 21px;
}
.smallButton{
    width:30px;
    height:30px;
}

:host ::ng-deep .mat-form-field {
    font-family: garamond !important;
    color: black;
    font-weight: 400;
}

:host .mat-form-field-wrapper {
    padding-bottom: 0px !important;
}

:host .mat-form-field-wrapper {
    padding-bottom: 0px !important;
}

:host .mat-form-field {
    padding: 0px
}

:host .mat-form-field-flex{
    padding: 0px !important;
}

:host .mat-select-value{
    text-align:center
}

:host .mat-form-field-underline {
    display: none;
}

:host .panel {
    max-height: 360px;
    border-radius: 25px;
}

#rolesRow:hover { 
    box-shadow: rgba(149, 157, 165, 0.1) 0px 8px 24px;
    border-radius: 20px;
    color: black;
    cursor:pointer;
}


/* .tr-hover:hover {
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 10px;
} */

/* td, th {
    white-space: normal;
    word-wrap: break-word;
} */







.pointer.active.desc:after {
    content: " ▼";
    color: #390263;
}
.pointer.active.asc:after {
    content: " ▲";
    color: #02661d
    
}

.color-box {
    width: 20px; 
    height: 20px; 
    border-radius: 5px;
    border: 1px solid black;}

.center-row {
    display: flex; flex-direction: row; align-items: center;
}

.shadow {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    padding: 5px;
    border-radius: 5px;
    margin-left: 10px;
}

#number-filter {
 border: null;
}

.btn-export{
    flex: 1;
    align-items: center;
    float:right;
}

.middle-header{
    display: flex;
    align-items: center;
}



/* table {
    table-layout: fixed;
}
td, span {
    word-wrap: break-word;
    word-break: break-all;
} */



`, "",{"version":3,"sources":["webpack://./src/app/open-roles/open-roles.component.css"],"names":[],"mappings":";;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;AACA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iDAAiD;IACjD,mBAAmB;IACnB,YAAY;IACZ,cAAc;AAClB;;;AAGA;;;;GAIG;;AAEH;;;GAGG;;;;;;;;AAQH;IACI,aAAa;IACb,cAAc;AAClB;AACA;IACI,aAAa;IACb;;AAEJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB,CAAC;;AAE5B;IACI,aAAa,EAAE,mBAAmB,EAAE,mBAAmB;AAC3D;;AAEA;IACI,wFAAwF;IACxF,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;CACC,YAAY;AACb;;AAEA;IACI,OAAO;IACP,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;;;AAIA;;;;;;GAMG","sourcesContent":["\n\n.smallIcon{\n    width: 21px;\n    height: 21px;\n    font-size: 21px;\n}\n.smallButton{\n    width:30px;\n    height:30px;\n}\n\n:host ::ng-deep .mat-form-field {\n    font-family: garamond !important;\n    color: black;\n    font-weight: 400;\n}\n\n:host .mat-form-field-wrapper {\n    padding-bottom: 0px !important;\n}\n\n:host .mat-form-field-wrapper {\n    padding-bottom: 0px !important;\n}\n\n:host .mat-form-field {\n    padding: 0px\n}\n\n:host .mat-form-field-flex{\n    padding: 0px !important;\n}\n\n:host .mat-select-value{\n    text-align:center\n}\n\n:host .mat-form-field-underline {\n    display: none;\n}\n\n:host .panel {\n    max-height: 360px;\n    border-radius: 25px;\n}\n\n#rolesRow:hover { \n    box-shadow: rgba(149, 157, 165, 0.1) 0px 8px 24px;\n    border-radius: 20px;\n    color: black;\n    cursor:pointer;\n}\n\n\n/* .tr-hover:hover {\n    cursor: pointer;\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n    border-radius: 10px;\n} */\n\n/* td, th {\n    white-space: normal;\n    word-wrap: break-word;\n} */\n\n\n\n\n\n\n\n.pointer.active.desc:after {\n    content: \" ▼\";\n    color: #390263;\n}\n.pointer.active.asc:after {\n    content: \" ▲\";\n    color: #02661d\n    \n}\n\n.color-box {\n    width: 20px; \n    height: 20px; \n    border-radius: 5px;\n    border: 1px solid black;}\n\n.center-row {\n    display: flex; flex-direction: row; align-items: center;\n}\n\n.shadow {\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n    padding: 5px;\n    border-radius: 5px;\n    margin-left: 10px;\n}\n\n#number-filter {\n border: null;\n}\n\n.btn-export{\n    flex: 1;\n    align-items: center;\n    float:right;\n}\n\n.middle-header{\n    display: flex;\n    align-items: center;\n}\n\n\n\n/* table {\n    table-layout: fixed;\n}\ntd, span {\n    word-wrap: break-word;\n    word-break: break-all;\n} */\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
